import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '@/api/services/SubscriptionService';
import { useAuth } from '@/stores/authContext';
import type { Subscription } from '@/types/priceAlert';

export const PRICE_ALERT_QUERY_KEY = ['priceAlert'] as const;

// Подписки на «лучшую цену продажи» (server-state). Включены только при авторизации; повторы — у транспорта.
export function usePriceAlerts() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: PRICE_ALERT_QUERY_KEY,
    queryFn: ({ signal }) => subscriptionService.getPriceAlerts(signal),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
  });
}

/** Сохранение настроек каналов; по успеху инвалидирует кэш подписок. */
export function useUpdatePriceAlerts() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (subscriptions: Subscription[]) => subscriptionService.updatePriceAlerts(subscriptions),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PRICE_ALERT_QUERY_KEY }),
  });
}
